import { Label } from '@cian/ui-kit';
import * as React from 'react';

export function BookedOfferLabel() {
  return (
    <Label color="text-inverted-default" background="accent-ghost-primary">
      Забронирована
    </Label>
  );
}
